import { Field } from './field';
import { Proxy } from './proxy';

export class Model {
  constructor(
    public autoLoad?: boolean,
    public entityName?: string,
    public idProperty?: boolean,
    public fields?: Field[],
    public proxy?: Proxy,
  ) { }
}
